import React from "react";
import styles from "./appointmentVisualization.module.css";

function AppointmentVisualization({ appointments }) {
    if (!appointments || appointments.length === 0) {
        return <p>Keine Trainingszeiten verfügbar.</p>;
    }

    const days = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

    const recurrenceDayMap = {
        MO: 0,
        TU: 1,
        WE: 2,
        TH: 3,
        FR: 4,
        SA: 5,
        SO: 6,
    };

    const formatTime = (timeStr) => timeStr.slice(0, 5);

    function parseRecurrenceDays(rule) {
        if (!rule) return [];
        const match = rule.match(/BYDAY=([^;]+)/);
        if (!match) return [];
        return match[1]
            .split(",")
            .map((d) => recurrenceDayMap[d])
            .filter((d) => d !== undefined);
    }

    const expandedAppointments = [];

    appointments.forEach((a) => {
        const recurrenceDays = parseRecurrenceDays(a.recurrence_rule);
        if (recurrenceDays.length === 0) {
            const date = new Date(a.appointment_date);
            const jsDay = date.getDay();
            const dayIndex = (jsDay + 6) % 7;
            expandedAppointments.push({ ...a, dayIndex });
        } else {
            recurrenceDays.forEach((dayIndex) => {
                expandedAppointments.push({ ...a, dayIndex });
            });
        }
    });

    const groupedByTitle = {};

    const getGroupKey = (a) => {
        if (a.title && a.title.trim()) return a.title.trim();
        // sensible fallbacks if there's no title:
        return ``;
        if (a.topic_type && a.topic_id != null) return `${a.topic_type}:${a.topic_id}`;
        // last-resort unique key
    };

    expandedAppointments.forEach((a) => {
        const key = getGroupKey(a);

        if (!groupedByTitle[key]) {
            groupedByTitle[key] = {
                // NOTE: no group-level location anymore
                days: {},
            };
        }

        if (!groupedByTitle[key].days[a.dayIndex]) {
            groupedByTitle[key].days[a.dayIndex] = [];
        }

        groupedByTitle[key].days[a.dayIndex].push({
            id: a.id,
            uhrzeit: `${formatTime(a.start_time)} - ${formatTime(a.end_time)}`,
            feldPos: a.additional_text || null,
            location: {
                id: a.location_id,
                name: a.location_name || "Unbekannter Ort",
                link: a.location_link_name
                    ? `https://maps.google.com/?q=${a.location_link_name}`
                    : "#",
            },
        });
    });
    return (
        <>
            {Object.entries(groupedByTitle).map(([title, group]) => (
                <div key={title || "no-title"} className={styles.appointmentGroup}>
                    {title && <h3 className={styles.appointmentTitle}>{title}</h3>}
                    <div className={styles.tableWrapper}>
                        <table className={`${styles.table} ${styles.tableColor}`}>
                            <thead>
                                <tr>
                                    <th>Tag</th>
                                    <th>Trainingszeiten</th>
                                    <th>Infos</th>
                                    <th>Ort</th>
                                </tr>
                            </thead>
                            <tbody>
                                {days.map((dayLabel, idx) => {
                                    const entries = group.days[idx];
                                    if (!entries || entries.length === 0) return null;
                                    return entries.map((entry, i) => (
                                        <tr key={entry.id}>
                                            {i === 0 && (
                                                <td className={styles.dayCell} rowSpan={entries.length}>
                                                    {dayLabel}
                                                </td>
                                            )}
                                            <td className={styles.timeCell}>{entry.uhrzeit}</td>
                                            <td className={styles.feldPosCell}>{entry.feldPos || "-"}</td>
                                            {i === 0 && (
                                                <td className={styles.locationCell} rowSpan={entries.length}>
                                                    <div className={styles.locationDiv}>
                                                        <p>{entry.location.name}</p>
                                                        <img
                                                            src="/assets/icons/google-map-icon.png"
                                                            alt={entry.location.name}
                                                            onClick={() => window.open(entry.location.link, "_blank")}
                                                            className={styles.mapIcon}
                                                        />
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    ));
                                })}
                            </tbody>
                        </table>
                    </div>

                </div>
            ))}
        </>
    );
}

export default AppointmentVisualization;
